import React, { useState } from 'react';
import './Colors.css';

const colors = [
  { name: 'Red', hex: '#FF0000' },
  { name: 'Green', hex: '#008000' },
  { name: 'Blue', hex: '#0000FF' },
  { name: 'Yellow', hex: '#FFFF00' },
  { name: 'Orange', hex: '#FFA500' },
  { name: 'Purple', hex: '#800080' },
  { name: 'Pink', hex: '#FFC0CB' },
  { name: 'Brown', hex: '#A52A2A' },
  { name: 'Gray', hex: '#808080' },
  { name: 'Black', hex: '#000000' },
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Violet', hex: '#EE82EE' },
  { name: 'Lime', hex: '#00FF00' },
  { name: 'Olive', hex: '#808000' },
  { name: 'Cyan', hex: '#00FFFF' },
  { name: 'SKy Blue', hex: '#87CEEB' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Beige', hex: '#F5F5DC' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'Rose', hex: '#FFE4E1' },
  { name: 'Maroon', hex: '#800000' },
];

const Colors = () => {
  const [selectedColor, setSelectedColor] = useState(null);
  const [quizColor, setQuizColor] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakColor = (colorName) => {
    const utterance = new SpeechSynthesisUtterance(colorName);
    window.speechSynthesis.speak(utterance);
  };

  const handleColorClick = (color) => {
    setSelectedColor(color);
    speakColor(color.name);
  };

  const startQuiz = () => {
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    setQuizColor(randomColor);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizColor.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct color was ${quizColor.name}`);
    }
  };
  const clearBoard = () => {
    // setBoard([...originalBoard]);
    window.location.reload();
   };

  return (
    <div className="AppColors">
      <h1>Learn Colors</h1>
      <div className="colors">
        {colors.map((color) => (
          <div
            key={color.name}
            className="color-box"
            style={{ backgroundColor: color.hex }}
            onClick={() => handleColorClick(color)}
          >
            {color.name}
          </div>
        ))}
      </div>
      {selectedColor && <div className="selected-color">You selected: {selectedColor.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizColor ? (
          <div>
            <p>What color is this?</p>
            <div
              className="quiz-color"
              style={{ backgroundColor: quizColor.hex }}
            ></div>
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter color name"
            />
            <button onClick={submitQuiz}>Submit</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
          
        )}
        <button onClick={clearBoard}>Re-Start</button>
      </div>
    </div>
  );
};

export default Colors;